import Settings from "../components/settings/Settings";

const SettingsView = () => {

    return (
        <div className="view">
            <h1 className="heading heading--lg">Settings</h1>
            <Settings />
        </div>
    )
};

export default SettingsView;
